import { useState } from "react";
import { useCreateBudget, useUpdateBudget } from "@/hooks/useBudget";

export type BudgetEditorState = {
  id?: number;
  category_id: number;
  amount: number;
  description?: string | null;
} | null;

export const useBudgetEditor = () => {
  const createMutation = useCreateBudget();
  const updateMutation = useUpdateBudget();
  const [isOpen, setIsOpen] = useState(false);
  const [state, setState] = useState<BudgetEditorState>(null);

  const open = (category: {
    budgetId?: number;
    id: number;
    budgetAmount?: number;
    budgetDescription?: string | null;
  }) => {
    setState({
      id: category.budgetId,
      category_id: category.id,
      amount: category.budgetAmount ?? 0,
      description: category.budgetDescription ?? null,
    });
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setState(null);
  };

  return {
    isOpen,
    state,
    open,
    close,
    createMutation,
    updateMutation,
  };
};
